import React, { useState, useEffect } from "react";
import Button from "@/common/elements/Button";
import Table from "@/common/elements/Table";
import { StyledFlex, StyledGridCol, StyledGridRow } from "@/common/styles";
import dayjs from "dayjs";
import { hasCheckSecurity, isNonEmptyVariable } from "@/util/common_function";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import {
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";
import { useSelector } from "react-redux";
import Modal from "@/common/elements/Modal";

const HouseAndTracksTable = ({
  details,
  handleAddClick,
  handleEditClick,
  handleOnRowClick,
  handleClearClick,
  handleLogClick,
  isEnabled,
  isRowSelected,
  setScheduled,
  setIsReturn,
  isInLoan,
  handleEditDoubleClick,
}) => {
  // Declarations
  const [tableData, setTableData] = useState();
  const { bookings, bookingsFieldsEnabled, isScheduledBooking } = useSelector(
    (state) => state?.bookings
  );
  const fullSearch = useSelector(state => state.fullSearch);
  const [isModalOpen, setIsModalOpen] = useState(false);
  function handleAdd() {
    if (!isInLoan || fullSearch) {
      handleAddClick();
      setIsModalOpen(false);
    } else {
      setIsModalOpen(true);
    }
  }
  const tableHeaders = [
    { key: "id", text: "#" },
    { key: "status", text: "Status" },
    { key: "actualDate", text: "Actual Date" },
    { key: "scheduledDate", text: "Scheduled Date" },
    { key: "expectedBack", text: "Expected Back" },
    { key: "summary", text: "Summary" },
  ];

  // Effects
  useEffect(() => {
    const data = details?.map((detail) => ({
      id: detail?.inmateTrackingID,
      status: detail?.movementStatus,
      actualDate: detail?.actualDate
        ? dayjs(`${detail?.actualDate} ${detail?.actualTime}`).format(
            "MM/DD/YYYY HH:mm"
          )
        : (!fullSearch ? dayjs().format("MM/DD/YYYY HH:mm") : null),
      scheduledDate:
        detail?.scheduledDate && detail?.scheduledTime
          ? dayjs(`${detail?.scheduledDate} ${detail?.scheduledTime}`).format(
              "MM/DD/YYYY HH:mm"
            )
          : null,
      expectedBack: detail?.expectedBackDate
        ? `${detail?.expectedBackDate} ${detail?.expectedBackTime}`
        : null,
      summary: detail?.comments,
    }));
    setTableData(data);
  }, [details]);

  return (
    <>
      <StyledGridRow justify="end">
        <StyledGridCol style={{ paddingBottom: "10px" }}>
          <StyledFlex align="center" gap="10px">
            <Button
              onClick={handleClearClick}
              disabled={
                !isEnabled ||
                !hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.ADD,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Arrest_Report
                )
              }
            >
              Clear
            </Button>
            {details?.length !== 0 && (
              <Button
                onClick={handleLogClick}
                disabled={
                  !isEnabled ||
                  !hasCheckSecurity(
                    Security_Types.functionality,
                    Entity_types.subModule,
                    LABELS_CAPITAL.VIEW,
                    MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                    SUB_MODULES_LIST_WITH_ID.Arrest_Report
                  )
                }
              >
                Movement Log
              </Button>
            )}
            <Button
              onClick={handleAdd}
              disabled={
                !isEnabled ||
                !hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.ADD,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Arrest_Report
                )
              }
            >
              Schedule Move
            </Button>
            <Button
              onClick={handleEditClick}
              disabled={
                !isRowSelected ||
                !hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.VIEW,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Arrest_Report
                )
              }
            >
              Details
            </Button>
          </StyledFlex>
        </StyledGridCol>
      </StyledGridRow>

      {hasCheckSecurity(
        Security_Types.functionality,
        Entity_types.subModule,
        LABELS_CAPITAL.VIEW,
        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
        SUB_MODULES_LIST_WITH_ID.Arrest_Report
      ) && (
        <Table
          headers={tableHeaders}
          onRowClick={handleOnRowClick}
          onRowDoubleClick={(data, index) => {
            handleEditDoubleClick(index);
          }}
          data={tableData}
        />
      )}
      {isModalOpen && (
        <Modal
          header={"Inmate Movement Details"}
          show={isModalOpen}
          size="xl"
          onHide={() => setIsModalOpen(false)}
          footerActions={[
            {
              key: "return",
              text: "Return",
              // isLoading: isLoading,
              onClick: () => {
                setIsReturn(true);
                handleAddClick();
                setIsModalOpen(false);
              },
            },
            {
              key: "schedule",
              text: "Schedule",
              // isLoading: isLoading,
              onClick: () => {
                setScheduled(true);
                handleAddClick();
                setIsModalOpen(false);
              },
            },
            {
              key: "cancel",
              text: "Cancel",
              // isLoading: isLoading,
              onClick: () => setIsModalOpen(close),
            },
          ]}
          footerCloseAction={() => setIsModalOpen(false)}
          footerCloseActionText="Close"
        >
          <p>
            This inmate is currently on a Loan. If you are returning the inmate
            to the facility,you should use the "Inmate Return" button
          </p>
          <p>
            Press <b>Return</b> to return the inmate from the Loan, or
          </p>
          <p>
            Press <b>Schedule</b> to continue adding details for a future move.
          </p>
        </Modal>
      )}
    </>
  );
};

export default HouseAndTracksTable;
